module.exports = __webpack_public_path__ + "media/wrong.dd18d3ba.mp3";